{
  "list": {
    "title": "Familii",
    "newFamily": "Familie nouă",
    "memberOne": "{count} membru",
    "memberMany": "{count} membri",
    "noContact": "fără persoană de contact",
    "noFamilies": "Nicio familie încă.",
    "selectEmptyHeading": "Selectează o familie",
    "selectEmptyMessage": "Alege o familie din stânga sau creează una."
  },
  "form": {
    "nameLabel": "Numele familiei",
    "namePlaceholder": "ex. familia Vinătoru",
    "create": "Creează",
    "deleteFamily": "Șterge familia"
  },
  "members": {
    "heading": "Membri",
    "setContactWarning": "⚠ Setează o persoană de contact pentru facturare — taxele familiei îi sunt facturate.",
    "billingContactBadge": "persoană de contact",
    "makeContact": "Setează contact",
    "remove": "Elimină",
    "noMembers": "Niciun membru încă.",
    "addStudentLabel": "Adaugă un cursant",
    "searchPlaceholder": "Caută după nume sau email…",
    "add": "Adaugă"
  },
  "fees": {
    "heading": "Taxe familie",
    "descriptionLabel": "Descriere",
    "descriptionPlaceholder": "ex. Taxă costum",
    "typeLabel": "Tip",
    "amountLabel": "Sumă",
    "currencyLabel": "Monedă",
    "dueDayLabel": "Zi scadentă",
    "familyFeeLabel": "Taxă familie",
    "familyFeePlaceholder": "Alege o taxă familie…",
    "addCharge": "Adaugă taxă personalizată",
    "addFee": "Adaugă taxă",
    "linkSharedInstead": "Asociază în schimb o taxă familie partajată",
    "addCustomCharge": "+ Adaugă o taxă personalizată",
    "noShared": "Nicio taxă familie partajată definită — alege „Adaugă o taxă personalizată” sau creează una în Setări → Facturare (Facturare: Per familie).",
    "customCharge": "taxă personalizată",
    "amountPerPeriod": "{amount}/perioadă",
    "noneSet": "Nicio taxă familie setată."
  },
  "payments": {
    "heading": "Plăți",
    "generateThisMonth": "Generează luna aceasta",
    "record": "Înregistrează",
    "emptyHeading": "Nicio plată de familie încă",
    "emptyMessage": "Setează o taxă + persoană de contact, apoi generează.",
    "recordModalHeading": "Înregistrează plata",
    "paymentFallback": "Plată",
    "paidVia": "Plătit prin",
    "methodDefault": "{name} (implicit)",
    "referenceLabel": "Referință (opțional)",
    "referencePlaceholder": "ex. ref transfer / nr. chitanță",
    "notesLabel": "Note (opțional)",
    "noEnabledMethods": "Nicio metodă de plată activă — adaugă una în Setări → Facturare.",
    "recordPayment": "Înregistrează plata",
    "col": {
      "due": "Scadență",
      "fee": "Taxă",
      "amount": "Sumă",
      "method": "Metodă",
      "status": "Stare"
    }
  },
  "feeType": {
    "monthly": "Lunară",
    "yearly": "Anuală",
    "occasional": "Ocazională",
    "event": "Eveniment"
  },
  "toast": {
    "failed": "Eșuat",
    "familyDeleted": "Familie ștearsă",
    "contactSet": "Persoană de contact setată",
    "enterChargeDetails": "Introdu o descriere și o sumă pentru taxa personalizată",
    "chooseFee": "Alege o taxă familie",
    "feeSet": "Taxă familie setată",
    "paymentsGenerated": "{count} plată/plăți generate",
    "chooseMethod": "Alege o metodă de plată",
    "paymentRecorded": "Plată înregistrată"
  }
}
